export const colors = {
  snappt: {
    700: '#577DB1',
    500: '#6A93CA',
    100: '#8FAED8',
    50: '#ebf1ff'
  },
  white: '#fff',
  black: {
    normal: '#1A202C',
    light: '#333',
    black: '#000'
  },
  gray: {
    10: '#ABB7C7',
    50: '#F9F9F9',
    90: '#E5E5E5',
    100: '#F3F4F6',
    150: '#E5E7EB',
    200: '#E2E8F0',
    250: '#D1D5DB',
    300: '#A0AEC0',
    350: '#9CA3AF',
    400: '#6B7280',
    500: '#4A5568',
    600: '#718096',
    700: '#4A5568',
    750: '#374151',
    800: '#1F2937',
    900: '#1A202C'
  },
  green: {
    50: '#E6F2EE',
    100: '#D1FAE5',
    150: '#DCFCE7',
    400: '#10B981',
    500: '#16A34A',
    600: '#4FA189',
    700: '#047857',
    800: '#166534'
  },
  red: {
    100: '#FEE2E2',
    400: '#EF4444',
    500: '#DC2626',
    600: '#D84343',
    700: '#C53030',
    800: '#991B1B'
  },
  yellow: {
    50: '#FEF5E7',
    100: '#FEF3C7',
    500: '#B45309',
    600: '#F8BB54',
    700: '#F59E0B',
    800: '#92400E'
  },
  blue: {
    50: '#F7FAFC',
    70: '#F4F9FF',
    75: '#EFF6FF',
    80: '#E6F5FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#EBF8FF',
    400: '#4DBCFC',
    500: '#009FFB',
    550: '#0090E6',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#1E40AF',
    900: '#1E3A8A'
  },
  purple: {
    100: '#f5f3ff',
    700: '#7C3AED',
    500: '#e6eaf4'
  },
  orange: {
    100: '#FFF3CD',
    700: '#C77B00'
  }
};

export const fonts = {
  normal: 'Roboto',
  bold: 'RobotoBold'
};

export const devices = {
  mobile: `(min-device-width: 320px) and (max-device-width: 900px)`,
  xs: `(max-width: 480px)`,
  tablet: `(max-width: 768px)`,
  laptop: `(max-width: 1024px)`,
  desktop: `(max-width: 2560px)`
};
